export default __webpack_public_path__ + "static/media/sodium-injection.5972af47.jpg";